export const theme = {
  colors: {
    whiteColor: "#fff",
    primaryColor: "#F1C115",
    darkColor: "#161616",
    bodyLColor: "#909090"
  },
  fontSizes: {
    body: "1rem",
    bodySM: ".9rem",
    bodyXS: ".8rem",
    bodyXXS: ".7rem",
    bodyXXXS: ".6rem",
    display: "3.5rem",
    heading1: "2.5rem",
    heading2: "2.25rem",
    heading3: "2rem",
    heading4: "1.5rem",
    heading5: "1.2rem",
    heading6: "1rem"
  },
  space: {
    levelAuto: "auto",
    level0: "0rem",
    level1: "0.33rem",
    level2: "0.66rem",
    level3: "1rem",
    level4: "1.5rem",
    level5: "2rem",
    level6: "4rem"
  },
  breakpoint: {
    onlyMobile: "(max-width: 767.98px)",
    upFromMobile: "(min-width: 768px)",
    onlyTablet: "(min-width: 768px) and (max-width: 991.98px)",
    upFromTablet: "(min-width: 992px)",
    downFromTablet: "(max-width: 991.98px)",
    tabletAndSmallDesktop: "(min-width: 768px) and (max-width: 1199.98px)",
    onlySmallDesktop: "(min-width: 992px) and (max-width: 1199.98px)",
    upFromSmallDesktop: "(min-width: 1200px)",
    downFromSmallDesktop: "(max-width: 1199.98px)"
  },
  boxShadow: {
    small: "0 2px 8px rgba(0, 0, 0, 0.15)",
    large: "0 10px 30px rgba(0, 0, 0, 0.05)",
    xlarge: "0 10px 30px rgba(0, 0, 0, 0.15)"
  },
  zIndex: {
    level1: "1010",
    level2: "1020",
    level3: "1030",
    level4: "1040",
    level5: "1050"
  }
};
